@if (initialized()) {
  <div class="page py-4">
    <div class="container-fluid container-site pt-3">
      <div class="row mb-4">
        <div class="col d-flex align-items-end">
          <div>
            <img
              src="/img/logo_liber_olive.webp"
              alt="Liber"
              height="30"
              class="me-3"
            />
          </div>

          <span class="d-block category-header h4 fw-light lh-1 mb-0">{{
            section.name
          }}</span>
        </div>
      </div>

      @if (data().length > 0) {
        @if (featured()) {
          <div class="row gy-4">
            <div class="col-12 col-md-8">
              <a
                class="featured-image"
                [routerLink]="['/articulo', featured()!.slug]"
              >
                <img
                  [src]="featured()!.image | assetFormatter"
                  class="img-zoomable"
                  [alt]="featured()!.title"
                />
              </a>
            </div>
            <div class="col-12 col-md-4 d-flex">
              <div class="align-self-end">
                <span class="text-uppercase category-badge">{{
                  featured()!.subject?.name
                }}</span>

                <h2>
                  <a [routerLink]="['/articulo', featured()!.slug]">{{
                    featured()!.title
                  }}</a>
                </h2>

                @if (
                  featured()?.meta_description &&
                  featured()!.meta_description.length > 130
                ) {
                  <div
                    [innerHTML]="
                      featured()!.meta_description.slice(0, 130) + '...'
                    "
                  ></div>
                } @else {
                  <div [innerHTML]="featured()!.meta_description"></div>
                }

                <hr class="separator my-1" />

                @if (featured()!.author) {
                  <a
                    class="author-label fw-semibold"
                    [routerLink]="['/buscar']"
                    [queryParams]="{ a: featured()!.author?.id }"
                  >
                    Por
                    {{
                      featured()!.author?.name +
                        " " +
                        featured()!.author?.surname
                    }}
                  </a>
                }
              </div>
            </div>
          </div>
        }

        <div class="row pt-5 g-4">
          @for (article of data(); track article.slug) {
            <div class="col-12 col-sm-6 col-md-3 pb-4">
              <div class="d-flex flex-column">
                <a
                  class="img-article mb-2"
                  [routerLink]="['/articulo', article.slug]"
                >
                  <img
                    [src]="article.image | assetFormatter"
                    class="img-zoomable"
                    [alt]="article.title"
                  />
                </a>

                <div class="mb-2">
                  <span class="text-uppercase category-badge mt-2">{{
                    article.subject?.name
                  }}</span>
                </div>

                <h3 class="h5 mb-2">
                  <a [routerLink]="['/articulo', article.slug]">{{
                    article.title
                  }}</a>
                </h3>

                @if (
                  article.meta_description &&
                  article.meta_description.length > 130
                ) {
                  <div
                    [innerHTML]="article.meta_description.slice(0, 130) + '...'"
                  ></div>
                } @else {
                  <div [innerHTML]="article.meta_description"></div>
                }

                @if (article.author) {
                  <a
                    class="author-label fw-semibold"
                    [routerLink]="['/buscar']"
                    [queryParams]="{ a: article!.author?.id }"
                    >Por
                    {{
                      article.author?.name + " " + article.author?.surname
                    }}</a
                  >
                }
              </div>
            </div>
          }
        </div>
      } @else {
        <div class="row py-5">
          <div class="col text-center text-muted">
            Todavía no hay artículos publicados en esta sección.
          </div>
        </div>
      }
    </div>
  </div>
}
